import React from 'react'
import StatusBar from '../../../components/aciacehighway/StatusBar'
import CngSection from '../../../components/cngcomponents/CngSection'
import CngSubSection from '../../../components/cngcomponents/CngSubSection'
import CngField from '../../../components/cngcomponents/CngField'
import TinyChip from '../../../components/aciacehighway/TinyChip'
import EquipmentInfoTable from './EquipmentInfoTable'
import ShipmentTable from './view/ShipmentTable'
import ResponseLog from './view/ResponseLog'
import History from './view/History'
import moment from 'moment-timezone'
import { Box, Card, Divider, Grid, Typography, useTheme } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function ManifestViewContent(props) {
  const {
    data,
    getCountryStateLabel,
    getLookupValue,
    id,
    isReviewPage,
    aceHighwayManifestTranslationText
  } = props

  const theme = useTheme()
  const iitCodes = [
    data.iitCode1,
    data.iitCode2,
    data.iitCode3,
    data.iitCode4
  ].filter((iitcode) => iitcode)

  function getLicensePlates() {
    const result = []

    // Loop 4 times because of API response's structure
    for (let i = 1; i <= 4; i++) {
      const plateNo = data[`licensePlateNo${i}`]
      const plateCountry = data[`licensePlateCountry${i}`]
      const plateState = data[`licensePlateState${i}`]

      // If any of 3 values exists, push to result array
      if (plateNo || plateCountry || plateState) {
        result.push({
          licensePlateNo: plateNo,
          licensePlateCountry: {
            label: getLookupValue('countries', plateCountry),
            value: plateCountry
          },
          licensePlateState: getCountryStateLabel(plateCountry, plateState)
        })
      }
    }

    return result
  }

  function getSealNos() {
    const result = []

    // Loop 9 times because of API response's structure
    for (let i = 1; i <= 9; i++) {
      if (data[`sealNo${i}`]) {
        result.push(data[`sealNo${i}`])
      }
    }

    return result
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <StatusBar status={data.status} />
      </Grid>
      <Grid item xs={12}>
        <CngSection title={aceHighwayManifestTranslationText.aceHighwayManifest}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <CngField label={aceHighwayManifestTranslationText.carrierScac}>
                {data.carrierScac}
              </CngField>
            </Grid>
            <Grid item xs={12} sm={6} md={8}>
              <CngField label={aceHighwayManifestTranslationText.tripNo}>
                {data.tripNo}
              </CngField>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <CngField label={aceHighwayManifestTranslationText.arrivalDate}>
                {data.arrivalDate &&
                  moment(data.arrivalDate).format('D MMM YYYY, HH:mm')}
              </CngField>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <CngField label={aceHighwayManifestTranslationText.transitIndicator}>
                <Typography component='div' variant='inherit'>
                  {getLookupValue('transportIndicator', data.transitIndicator)}
                  <TinyChip label={data.transitIndicator} variant='outlined' />
                </Typography>
              </CngField>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <CngField label={aceHighwayManifestTranslationText.firstExpectedPort}>
                <Typography component='div' variant='inherit'>
                  {getLookupValue('firstExpectedPort', data.firstExpectedPort)}
                  <TinyChip label={data.firstExpectedPort} variant='outlined' />
                </Typography>
              </CngField>
            </Grid>
          </Grid>
        </CngSection>
      </Grid>
      <Grid item xs={12}>
        <CngSection title={aceHighwayManifestTranslationText.aceHighwayTruckConveyance}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box paddingTop={1} paddingBottom={2}>
                <Grid container justify='space-between' spacing={3}>
                  <Grid item xs={12} md='auto'>
                    <Typography color='textSecondary' variant='body2'>
                      {data.aceFlag
                        ? aceHighwayManifestTranslationText.conveyanceWithAceNo
                        : aceHighwayManifestTranslationText.conveyanceWithoutAceNo}
                    </Typography>
                  </Grid>
                  {data.aceFlag && (
                    <Grid item xs={12} md='auto'>
                      <Typography
                        component='span'
                        variant='body2'
                        color='textSecondary'
                      >
                        {aceHighwayManifestTranslationText.aceId}
                      </Typography>
                      <Typography
                        component='span'
                        variant='body2'
                        color='textSecondary'
                      >
                        :&nbsp;
                      </Typography>
                      <Typography
                        component='span'
                        variant='body2'
                        style={{ fontWeight: 700 }}
                      >
                        {data.aceId}
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </Box>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                  <CngField label={aceHighwayManifestTranslationText.conveyanceType}>
                    <Typography component='div' variant='inherit'>
                      {getLookupValue('conveyanceType', data.conveyanceType)}
                      <TinyChip label={data.conveyanceType} variant='outlined' />
                    </Typography>
                  </CngField>
                </Grid>
                <Grid item xs={12} md={4}>
                  <CngField label={aceHighwayManifestTranslationText.conveyanceNo}>
                    {data.conveyanceNo}
                  </CngField>
                </Grid>
                <Grid item xs={12} md={4}>
                  <CngField label={aceHighwayManifestTranslationText.email}>
                    {data.email}
                  </CngField>
                </Grid>
              </Grid>
            </Grid>
            {getLicensePlates().length > 0 && (
              <Grid item xs={12}>
                <CngSubSection
                  title={aceHighwayManifestTranslationText.licensePlate}
                  style={{ marginBottom: 16 }}
                >
                  <Grid container spacing={2}>
                    {getLicensePlates().map((plate, index) => (
                      <React.Fragment key={index}>
                        <Grid item xs={12}>
                          <Grid container spacing={3}>
                            <Grid item xs={12} sm={6} md={4}>
                              <CngField label={aceHighwayManifestTranslationText[`licensePlateNo${index + 1}`]}>
                                {plate.licensePlateNo}
                              </CngField>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <CngField label={aceHighwayManifestTranslationText[`licensePlateCountry${index + 1}`]}>
                                <Typography component='div' variant='inherit'>
                                  {plate.licensePlateCountry.label}
                                  <TinyChip label={plate.licensePlateCountry.value} variant='outlined' />
                                </Typography>
                              </CngField>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <CngField label={aceHighwayManifestTranslationText[`licensePlateCountry${index + 1}`]}>
                                {plate.licensePlateState}
                              </CngField>
                            </Grid>
                          </Grid>
                        </Grid>
                        {getLicensePlates().length !== index + 1 && (
                          <Grid item xs={12}>
                            <Divider />
                          </Grid>
                        )}
                      </React.Fragment>
                    ))}
                  </Grid>
                </CngSubSection>
              </Grid>
            )}
            {getSealNos().length > 0 && (
              <Grid item xs={12}>
                <CngSubSection title={aceHighwayManifestTranslationText.sealNos}>
                  <Grid container spacing={2}>
                    {getSealNos().map((sealNo, index) => (
                      <Grid key={index} item xs={12} sm={6} md={3}>
                        <CngField label={aceHighwayManifestTranslationText[`sealNo${index + 1}`]}>
                          {sealNo}
                        </CngField>
                      </Grid>
                    ))}
                  </Grid>
                </CngSubSection>
              </Grid>
            )}
            <Grid item xs={12}>
              <CngSubSection title={aceHighwayManifestTranslationText.instrumentsOfInternationalTraffic}>
                {iitCodes.length > 0 ? (
                  <Grid container spacing={3}>
                    {iitCodes.map(
                      (iitCode, index) =>
                        iitCode !== '' && (
                          <Grid item key={`iitCode${index + 1}`} xs={12} md={6}>
                            <Box display='flex' style={{ gap: 8 }}>
                              <Box
                                display='flex'
                                alignItems='center'
                                justifyContent='center'
                                height={24}
                                width={24}
                              >
                                <FontAwesomeIcon
                                  icon={['fal', 'check']}
                                  color={theme.palette.primary.main}
                                />
                              </Box>
                              <Box display='flex' flexDirection='column'>
                                <Typography>{iitCode}</Typography>
                                <Typography>
                                  {aceHighwayManifestTranslationText[`iitCode${index + 1}`]}
                                </Typography>
                              </Box>
                            </Box>
                          </Grid>
                        )
                    )}
                  </Grid>
                ) : (
                  <Typography variant='body2' color='textSecondary'>
                    {aceHighwayManifestTranslationText.noRecorsToDisplay}
                  </Typography>
                )}
              </CngSubSection>
            </Grid>
          </Grid>
        </CngSection>
      </Grid>
      <Grid item xs={12}>
        <CngSection
          title={
            <Box display='flex' alignItems='baseline' style={{ gap: 4 }}>
              <Typography style={{ fontWeight: 600 }}>
                {aceHighwayManifestTranslationText.equipmentInfo}
              </Typography>
              <Typography color='textSecondary' variant='caption'>
                {`/ ${data.equipmentInfo.length} ` + aceHighwayManifestTranslationText.entries}
              </Typography>
            </Box>
          }
        >
          <EquipmentInfoTable data={data.equipmentInfo} />
        </CngSection>
      </Grid>
      <Grid item xs={12}>
        <CngSection title={aceHighwayManifestTranslationText.partyInfo}>
          {data.partyInfo.length > 0 ? (
            <Grid container spacing={2}>
              {data.partyInfo.map(party => (
                <Grid key={party.id || party._id} item xs={12}>
                  <Card variant='outlined' style={{ backgroundColor: theme.palette.grey[50] }}>
                    <Box padding={2}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                          <CngField label={getLookupValue('crewType', party.partyType)}>
                            {[party.firstName, party.middleName, party.lastName]
                              .filter((name) => name)
                              .join(' ')}
                          </CngField>
                        </Grid>
                        <Grid item xs={12} md={8}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                              <CngField label={aceHighwayManifestTranslationText.documentType}>
                                {party.aceIdFlag && aceHighwayManifestTranslationText.partyAceId}
                                {party.fastCardFlag && aceHighwayManifestTranslationText.fastCard}
                              </CngField>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <CngField label={aceHighwayManifestTranslationText.documentNo}>
                                {party.aceIdFlag && party.aceId}
                                {party.fastCardFlag && party.fastCard}
                              </CngField>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <CngField label={aceHighwayManifestTranslationText.telNo}>
                                {party.telNo}
                              </CngField>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <CngField label={aceHighwayManifestTranslationText.email}>
                                {party.email}
                              </CngField>
                            </Grid>
                          </Grid>
                        </Grid>
                        {!party.fastCardFlag && (
                          <>
                            <Grid item xs={12}>
                              <Grid alignItems='center' container spacing={2}>
                                <Grid item xs={12} sm='auto'>
                                  <Typography variant='body2' color='textSecondary' style={{ fontWeight: 600 }}>
                                    {aceHighwayManifestTranslationText.partyInfoAddressTitle}
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} sm>
                                  <Divider />
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item xs={12}>
                              <CngField label={aceHighwayManifestTranslationText.address}>
                                {[
                                  party.address1,
                                  party.address2,
                                  party.address3
                                ]
                                  .filter((address) => address)
                                  .join(', ')}
                              </CngField>
                            </Grid>
                          </>
                        )}
                      </Grid>
                    </Box>
                  </Card>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Typography variant='body2' color='textSecondary'>
              {aceHighwayManifestTranslationText.noRecorsToDisplay}
            </Typography>
          )}
        </CngSection>
      </Grid>
      <Grid item xs={12}>
        <CngSection title={aceHighwayManifestTranslationText.insuranceInfo}>
          {data.insuranceInfo.length > 0 ? (
            <Grid container spacing={2}>
              {data.insuranceInfo.map((insurance, index) => (
                <React.Fragment key={insurance.id}>
                  <Grid item xs={12}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6} md={3}>
                        <CngField label={aceHighwayManifestTranslationText.insuranceCompany}>
                          {insurance.insuranceCompany}
                        </CngField>
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <CngField label={aceHighwayManifestTranslationText.insurancePolicyNo}>
                          {insurance.insurancePolicyNo}
                        </CngField>
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <CngField label={aceHighwayManifestTranslationText.yearOfIssuance}>
                          {moment(insurance.yearOfIssuance).format('YYYY')}
                        </CngField>
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <CngField label={aceHighwayManifestTranslationText.liabilityAmount}>
                          {`$ ${parseFloat(insurance.liabilityAmount).toFixed(
                            2
                          )}`}
                        </CngField>
                      </Grid>
                    </Grid>
                  </Grid>
                  {data.insuranceInfo.length !== index + 1 && (
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                  )}
                </React.Fragment>
              ))}
            </Grid>
          ) : (
            <Typography variant='body2' color='textSecondary'>
              {aceHighwayManifestTranslationText.noRecorsToDisplay}
            </Typography>
          )}
        </CngSection>
      </Grid>
      <Grid item xs={12}>
        <CngSection
          title={
            <Box display='flex' alignItems='baseline' style={{ gap: 4 }}>
              <Typography style={{ fontWeight: 600 }}>
                {aceHighwayManifestTranslationText.aceManifestShipment}
              </Typography>
              <Typography color='textSecondary' variant='caption'>
                {/*`/ ${data.shipmentInfo.length} Entries`*/}
              </Typography>
            </Box>
          }
        >
          <ShipmentTable
            //data={data.shipmentInfo}
            getCountryStateLabel={getCountryStateLabel}
            getLookupValue={getLookupValue}
            manifestId={data.id}
            manifestPort={data.firstExpectedPort}
          />
        </CngSection>
      </Grid>
      <Grid item xs={12}>
        <CngSection title={aceHighwayManifestTranslationText.statusNotificationTitle}>
          {data.statusNotificationInfo.length > 0 ? (
            <Grid container spacing={3}>
              {data.statusNotificationInfo.map((notification, index) => (
                <React.Fragment key={notification.id}>
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6} md={4}>
                        <CngField label={aceHighwayManifestTranslationText.statusNotificationName}>
                          {notification.name}
                        </CngField>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <CngField label={aceHighwayManifestTranslationText.statusNotificationEmail}>
                          {notification.email}
                        </CngField>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <CngField label={aceHighwayManifestTranslationText.statusNotificationSnType}>
                          {notification.snType}
                        </CngField>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <CngField label={aceHighwayManifestTranslationText.statusNotificationShipmentControlNum}>
                          {notification.shipmentControlNum}
                        </CngField>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <CngField label={aceHighwayManifestTranslationText.statusNotificationMobileNum}>
                          {notification.mobileNum}
                        </CngField>
                      </Grid>
                    </Grid>
                  </Grid>
                  {data.statusNotificationInfo.length !== index + 1 && (
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                  )}
                </React.Fragment>
              ))}
            </Grid>
          ) : (
            <Typography variant='body2' color='textSecondary'>
              {aceHighwayManifestTranslationText.noRecorsToDisplay}
            </Typography>
          )}
        </CngSection>
      </Grid>
      {!isReviewPage && (
        <>
          <Grid item xs={12}>
            <ResponseLog manifestId={id} />
          </Grid>
          <Grid item xs={12}>
            <History manifestId={id} />
          </Grid>
        </>
      )}
    </Grid>
  )
}

export default ManifestViewContent
